




import {Vue, Component} from 'vue-property-decorator'

import Broadcast  from '@/components/Broadcast.vue'

@Component({
  components: {
      Broadcast
  }
})
export default class BroadcastView extends Vue {
}
